export default function ProductLoading({ error, retry }: { error?: string; retry: () => void }) {
  return <main aria-busy={!error} style={{ padding: 32, background: '#fff', minHeight: '100dvh' }}>
    <p role={error ? 'alert' : 'status'}>{error || 'Загрузка…'}</p>
    {error && <button type="button" onClick={retry}>Повторить</button>}
  </main>
}
